import React from 'react';
import { CookiePreferences } from '../../components/sections/CookiePreferences';
import { LegalDocument } from '../../components/sections/LegalDocument';
import { PageHero } from '../../components/ui/PageHero';
import { cookieSections } from '../../data/legal';
import { usePageMeta } from '../../hooks/usePageMeta';
export function Cookies() {
  usePageMeta('Cookie Policy', 'How the Aurevane Search Partners website uses cookies and browser storage, and how to manage your preferences.');
  return <>
      <PageHero compact label="Legal" title="Cookie Policy" intro="What we store in your browser, and how to control it." data-id="element-902" data-mp="qull19cu1fuc" />
      <LegalDocument sections={cookieSections} data-id="element-903" data-mp="c676i16202xy">
        <CookiePreferences data-id="element-904" data-mp="h3h4i57idmxe" />
      </LegalDocument>
    </>;
}